export const normalizeAttributeValue = (attrValue) => {
    try {
        if (typeof attrValue === 'string') {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return JSON.parse(attrValue);
        }
        return attrValue;
    }
    catch (e) {
        return attrValue;
    }
};
//# sourceMappingURL=normalizeAttributeValue.js.map